;(function ($) {
"use strict";
})(jQuery);
